import React, { useEffect } from "react";
import styled from "styled-components";
import { Avatar } from "../data";
import { Container } from "./reusable_components";
import { init } from "ityped";

const AvatarCircleBox = styled.div`
  width: 385px;
  height: 431px;
  background: radial-gradient(
    50% 50% at 50% 50%,
    #763cac 0%,
    rgba(50, 15, 133, 0) 100%
  );
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));

  @media (max-width: 700px) {
    width: 100%;
    height: 391px;
  }
`;
const AvatarBox = styled.div`
  width: 258px;
  height: 258px;
  background-image: url(${Avatar});
  background-size: cover;
  background-position: center;

  @media (max-width: 700px) {
    width: 210px;
    height: 210px;
  }
`;
const IntroBox = styled.div`
  width: 40%;
  height: auto;
  @media (max-width: 700px) {
    width: 80%;
  }
`;
const Addressing = styled.span`
  position: absolute;
  top: 0%;
  left: 15%;
  color: #fff;
  letter-spacing: 1px;
`;
const MainAvatar = () => {
  useEffect(() => {
    const myElement = document.querySelector("#username");
    init(myElement, {
      showCursor: true,
      strings: ["Prem Prakash"],
      typeSpeed: 250,
    });
  });

  return (
    <Container className="d-flex align-center" style={{ position: "relative" }}>
      <Addressing>
        Hello! I Am <span id="username" style={{ color: "#7127BA" }}></span>{" "}
      </Addressing>
      <AvatarCircleBox className="d-flex justify-center align-center">
        <AvatarBox data-aos="zoom-in"></AvatarBox>
      </AvatarCircleBox>
      <IntroBox
        style={{
          fontFamily: "Preahvihear",
          color: "#fff",
          fontWeight: "100",
          letterSpacing: "3px",
        }}
      >
        <p className="a_dsigner">A Developer who</p>
        <h1>
          Judges a project <br /> by its{" "}
          <span
            className="coverText"
            style={{ color: "#7127BA", display: "inline-block" }}
          >
            code
          </span>
          ...
        </h1>
        <p style={{ fontSize: "13px" }}>
          Because if the code is not clean and efficient, what else matters?
        </p>
      </IntroBox>
    </Container>
  );
};

export default MainAvatar;
